import { gql } from "@apollo/client";

export const UPDATE_BOOKING_STATUS = gql`
  mutation updateBookingState(
    $id: ID!
    $state: String
    $isTurnedAway: Boolean
    $isNoShow: Boolean
  ) {
    updateBookingState(
      id: $id
      isTurnedAway: $isTurnedAway
      isNoShow: $isNoShow
      state: $state
    ) {
      id
      state
    }
  }
`;
